package com.milta.core.localization.translations.bg

import com.milta.core.localization.ErrorStrings

internal val Errors = ErrorStrings(
    generic = "Възникна грешка",
    error = "Грешка",
    fieldRequired = "Това поле е задължително",
    invalidEmail = "Невалиден имейл адрес",
    fileTooLarge = "Файлът е твърде голям. Изберете по-лек файл.",
)
